//General
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog'; // Actualización aquí
import { MessageBoxComponent } from 'src/app/modales/message-box/message-box.component';
//Error
import { ErrorStateMatcher } from '@angular/material/core';
/** Error when invalid control is dirty, touched, or submitted. **/
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
//Servicio
import { ControlEscolarService } from 'src/app/services/control-escolar.service';
//Tabla
import { MatPaginator, PageEvent } from '@angular/material/paginator'; // Actualización aquí
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table'; // Actualización aquí
//Fin Tabla
//Detectar cambios de archivos
import { ChangeDetectorRef } from '@angular/core'; //Detectar cambios

@Component({
    selector: 'app-historial-de-pagos',
    templateUrl: './historial-de-pagos.component.html',
    styleUrls: ['./historial-de-pagos.component.scss'],
    providers: [ControlEscolarService],
    standalone: false
})
export class HistorialDePagosComponent implements OnInit {

  /*tabla*/
  public length: number = 100;
  public pageSize: number = 10;
  public pageSizeOptions: Array<number> = [5, 10, 25, 100];
  public page: number = 1;
  public displayedColumns: any = [
    'id',
    'concepto',
    'monto',
    //'eliminar'
  ];
  public dataSource: any;
  /*fin tabla*/
  public isLoading: boolean = false;
  public laravelapiStorage: any;
  public t: any;

  @Input() id_alumno: number = -1;
  @Input() id_ciclo: number = -1;

  public id_alumno_pro: number = -1;
  public id_ciclo_pro: number = -1;

  constructor(
    private fb: FormBuilder,
    public _dialog: MatDialog,
    private _ControlEscolarService: ControlEscolarService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cdRef: ChangeDetectorRef,
  ) {
    this.getConsultaPagosAlumno(1);
    //this.laravelapiStorage = this._ControlEscolarService.getLaravelApiStorageTutores();
  }

  ngOnInit(): void {
  }

  public getConsultaPagosAlumno(page: number) {
    this.page = page;
    this.isLoading = true;
    this._ControlEscolarService.getConsultaPagosAlumno(this.page, this.pageSize, this.id_alumno_pro, this.id_ciclo_pro).subscribe(
      (response: any) => {
        console.log(response);
        this.isLoading = false;
        if (response.estado == 200) {
          this.length = response.data.length;
          this.dataSource = response?.data?.data[0]?.tesoreria_pagos;
        }
      },
      (error: any) => {
        console.log(<any>error);
        this.isLoading = false;
      });
  }

  /*public postEliminarDocumentosOrg(id: number){
    this.isLoading = true;
    this._ControlEscolarService.postEliminarDocumentosOrg({numero_documento: id}).subscribe(
      response => {console.log(response);
        this.isLoading = false;
        if(response.estado == 200){
          this._dialog.open(MessageBoxComponent,{ disableClose: true ,data: {titulo: 'Operación Exitosa', mensaje: response.mensaje, icon:'correct'}});
          this.getConsultaPagosAlumno();
        }else{
          this._dialog.open(MessageBoxComponent,{ disableClose: true ,data: {titulo: 'Error', mensaje: response.mensaje, icon:'error'}});
        }
      },
      error => {console.log(<any>error);
        this._dialog.open(MessageBoxComponent, { disableClose: true ,data: {titulo: 'Error', mensaje: 'Error con el Servicio.', icon:'error'}});
        this.isLoading = false;
      });
  }*/

  ngAfterContentChecked() {
    this.t = new Date().getTime();
    this._cdRef.detectChanges();

    if (this.id_alumno != this.id_alumno_pro || this.id_ciclo != this.id_ciclo_pro) {
      console.log('cambios');
      this.id_alumno_pro = this.id_alumno;
      this.id_ciclo_pro = this.id_ciclo;
      this.getConsultaPagosAlumno(1);
    }
  }

  public pageEvent(event: PageEvent) { // Actualización aquí
    console.info(event);
    this.pageSize = event.pageSize;
    this.getConsultaPagosAlumno(event.pageIndex + 1);
  }
}
